import { system } from '@eastcoal/common/config/system'

import { RouterLink } from '@eastcoal/router/components/Link'

import { MemberStatus } from '../../enums/MemberStatus'
import { MemberStatusTag } from '../MemberStatusTag'

import { MemberStatusLinkProps } from './interface'

export const MemberStatusLink = ({
  memberStatus,
  hideSuccessStatus = true
}: MemberStatusLinkProps) => {
  return hideSuccessStatus &&
    memberStatus === MemberStatus.SUCCESS ? null : (
    <RouterLink
      title='点击前往认证管理页面'
      to={`${system.router.memberBaseUrl}/audit/list`}
    >
      <MemberStatusTag
        memberStatus={memberStatus}
        hideSuccessStatus={hideSuccessStatus}
      />
    </RouterLink>
  )
}
